import { AnyAction } from 'redux';
import { AntragsnummerGeneratedAction, JhpActions } from '../jhpActions';
import { IAppState } from '../appState';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: AnyAction,
): IAppState['antragsnummer'] {
  switch (action.type) {
    case JhpActions.ANTRAGSNUMMER_GENERATED:
      return (action as AntragsnummerGeneratedAction).payload.antragsnummer;
    default:
      return sectionState;
  }
};
